<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          :url="this.$store.state.authUser ? '/dashboard' : '/quiz-home'"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          @click="toggleSidebar"
          :navText="$t('HOME')"
        >
          <template v-slot:icon>
            <i class="fas fa-home text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="this.$store.state.authUser">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          @click="toggleSidebar"
          :navText="$t('PROFILE')"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="this.$store.state.authUser">
        <sidenav-item
            url="/settings"
            :class="getRoute() === 'settings' ? 'active' : ''"
            @click="toggleSidebar"
            :navText="$t('SETTINGS')"
        >
          <template v-slot:icon>
            <i class="ni ni-settings text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          url="/challenge-list"-->
<!--          :class="getRoute() === 'challenge-list' ? 'active' : ''"-->
<!--          @click="toggleSidebar"-->
<!--          :navText="$t('CHALLENGES')"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-trophy text-primary text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->
      <li class="nav-item" v-if="this.$store.state.authUser">
        <sidenav-item
            url="/purchase-history"
            :class="getRoute() === 'purchase-history' ? 'active' : ''"
            @click="toggleSidebar"
            :navText="$t('PURCHASE_HISTORY')"
        >
          <template v-slot:icon>
            <i class="ni ni-basket text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" target="_blank" v-bind="$attrs" @click.prevent="micrositeRoute('privacy-policy')">
          <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-shield-alt text-primary text-sm opacity-10"></i>
          </div>
          <span
              class="nav-link-text"
              :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
          >{{ $t('PRIVACY') }}</span
          >
        </a>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" target="_blank" v-bind="$attrs" @click.prevent="micrositeRoute('terms-of-service')">
          <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-file-alt text-primary text-sm opacity-10"></i>
          </div>
          <span
              class="nav-link-text"
              :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
          >{{ $t('TERMS_CONDITION') }}</span
          >
        </a>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" target="_blank" v-bind="$attrs" @click.prevent="micrositeRoute('faq')">
          <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-question-circle text-primary text-sm opacity-10"></i>
          </div>
          <span
              class="nav-link-text"
              :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
          >{{ $t('FAQ') }}</span
          >
        </a>
      </li>

    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Quizgiri",
      controls: "dashboardsExamples",
      isActive: "active",
      privacyUrl: process.env.VUE_APP_MICROSITE_BASE_API + '/privacy-policy',
    };
  },
  components: {
    SidenavItem,
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    micrositeRoute(address) {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
      window.open(process.env.VUE_APP_MICROSITE_BASE + address, '_blank');
    }
  }
};
</script>
